import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import './styles.less';

const Input = (props) => {
    const handleInputChange = (e) => props.onChange(e.target.value);

    return (
        <div>
            <input {...props} className="p-input" onChange={handleInputChange} />
            {props.icon ? (
                <span>
                    <Icon className="p-input__icon" icon={props.icon} />
                </span>
            ) : null}
        </div>
    );
};

Input.propTypes = {
    onChange: PropTypes.func.isRequired,
    icon: PropTypes.string
};

Input.defaultProps = {
    icon: 'search'
};

export default Input;
